var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeePage',[_c('GroupTable',{staticClass:"card",attrs:{"rows":_vm.groups,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }